//DIDSection2

// src/components/DIDSection2.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:50%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  
  @media (max-width: 500px) {
    width:70%;
    text-align: center;
    
  }
  
`;

const Title = styled.h2`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;

  span{
    color: #FFF56A;
  }

  @media (max-width: 500px){
    font-size: 32px;
    line-height: 46px;
  }

`;

const RightColumn = styled.div`
  flex: 6; 
  max-width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;

  @media (max-width: 500px) {
    max-width:100%;
    padding:0% ;

  }
  
`;

const GroupContainer = styled.div`
  margin-bottom: 2.5%; 
  border-bottom: 1px solid #3F3F3F;
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 0%; 
  color: #FFFFFF;

  span{
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`;

const GroupDescription = styled.p`

  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #AFAFAF;
  padding:0% 0% 2.5% 2.5%;
  margin-top: 0%; 

  @media (max-width: 500px) {
    max-width:100%;
    padding:1% 0% 2.5% 4%;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    
  }
  
`;

const DIDSection2 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Title>我們為什麼需要分散式身分<span>.</span></Title>
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle><span>•</span> 人工智慧的溯源需求：</GroupTitle>
          <GroupDescription>
            AI 技術的進步使得假信息傳播更加精細也更具規模，現有的身分驗證系統暴露出脆弱性。為了民主社會的穩定，分散式身分證明技術被提倡，以防止身分資料被操控並降低系統攻擊的風險。
          </GroupDescription>
        </GroupContainer>
        <GroupContainer>
          <GroupTitle><span>•</span> 全球隱私保護趨勢：</GroupTitle>
          <GroupDescription>
            隨著 GDPR 的實施，全球隱私保護意識提高。新工具如 GPC 與 Permission Slip 讓消費者更容易控制個人隱私，而如 CPRA 等法規反映了 GDPR 不足之處。數據保護變得至關重要，而合理的身分管理系統對於保護個人資料變得更加重要。
          </GroupDescription>
        </GroupContainer>
        <GroupContainer>
          <GroupTitle><span>•</span> 國際身分問題：</GroupTitle>
          <GroupDescription>
            隨著國際上因政治、戰爭、氣候原因而被迫移動的人們數量持續增加，身分驗證及隱私在極端情況下變得困難，這限制了他們的遷移和安置。更有韌性，保護隱私的身分認證方式有助於解決這一挑戰。
          </GroupDescription>
        </GroupContainer>
      </RightColumn>
    </SectionContainer>
  );
};

export default DIDSection2;
